export default __webpack_public_path__ + "static/media/port17.0346da35.jpg";